import React from 'react';

export default function IndexSectionFootersLightReverse2() {
    return (
        <React.Fragment>
            <>
                <section className="py-10 bg-gray-50 overflow-hidden">
  <div className="container mx-auto px-4">
    <div className="py-16 px-8 bg-white rounded-3xl">
      <div className="flex flex-col justify-center">
        <a className="inline-block max-w-max mx-auto mb-10" href="#">
          <img src="https://static.shuffle.dev/uploads/files/bd/bd9a85b8a4fa1ba404318e6dc3a1410c26c46d6a/FullLogo.png" alt className="h-48" />
        </a>
        <ul className="-m-6 mb-7 text-center">
          <li className="inline-flex p-6">
          </li><li className="inline-flex p-6">
          </li><li className="inline-flex p-6">
          </li><li className="inline-flex p-6">
          </li><li className="inline-flex p-6">
          </li></ul>
        <div className="flex flex-wrap justify-center -m-4 mb-12">
          <div className="w-auto p-4">
            <a className="block" href="#">
            </a>
          </div>
          <div className="w-auto p-4">
            <a className="block" href="#">
            </a>
          </div>
        </div>
        <p className="text-center font-bold">
          <span>Ⓒ Copyright 2025. All rights reserved by </span>
          <a className="text-blue-500 hover:text-blue-600" href="#">FilingIQ</a>
        </p>
      </div>
    </div>
  </div>
</section>


            </>
        </React.Fragment>
    );
}

